import GridCol from 'components/atoms/GridCol';
import React from 'react';
import Field from 'components/molecules/Field';
import Grid from 'components/atoms/Grid';
import 'styled-components/macro';
import Switch from 'components/atoms/Switch';
import { CheckboxHolder, GroupFieldHeading, CompactSection, SectionHeader } from './configuration.styles';

function FooterLines({ state, section, onChange = () => {} }) {
  return (
    <CompactSection>
      <SectionHeader>
        <span className="material-icons-outlined" css="font-size: 18px;">
          receipt_long
        </span>
        Receipt Footer Lines
        <CheckboxHolder css="margin-left: auto;">
          <Switch noMargin label="Enable" name={`${section}.value`} value={state.value} onChange={onChange} />
        </CheckboxHolder>
      </SectionHeader>

      <Grid xs={1} sm={2} lg={3} colGap={20} rowGap={15}>
        {Object.entries(state).map(
          ([k, v], idx) =>
            k !== 'value' && (
              <GridCol key={k}>
                <div css="background: white; padding: 12px; border-radius: 6px; border: 1px solid #e9ecef;">
                  <GroupFieldHeading css="margin-bottom: 8px; font-size: 14px;">
                    Footer Line {idx + 1}
                  </GroupFieldHeading>
                  <Field
                    sm
                    margin={1}
                    name={`${section}.${k}.en`}
                    type="text"
                    label="English"
                    value={v.en}
                    onChange={onChange}
                    disabled={!state.value}
                  />
                  <Field
                    sm
                    margin={0}
                    name={`${section}.${k}.fr`}
                    type="text"
                    label="French"
                    value={v.fr}
                    onChange={onChange}
                    disabled={!state.value}
                  />
                </div>
              </GridCol>
            ),
        )}
      </Grid>
    </CompactSection>
  );
}

export default FooterLines;
